<template>
  <div class="banner">
    <div class="banner-wrapper">
      <!-- 左侧标题 -->
      <div class="content-ai">
        <img class="content-ai-logo" :src="isMobile ? data.mobileAiLogo : data.aiLogo" />
        <p class="content-ai-titleCh">{{data.titleCh}}</p>
        <p class="content-ai-titleEn">{{data.titleEn}}</p>
        <div class="content-ai-title-logo-content">
          <img class="content-ai-title-logo" :src="data.titleLogo"/>
        </div>
      </div>

      <!-- 右侧二维码 && 链接 -->
      <div class="content-wrapper">
        <div class="content-qr">
          <div class="content-qr-wrapper">
            <img class="content-qr-img" :src="isMobile ? data.mobileQrMiddle : data.qrMiddle">
            <div class="content-list-link">{{data.weChatAccounts}}</div>
          </div>
          <div class="content-qr-wrapper">
            <img class="content-qr-img" :src="isMobile ? data.qrQt : data.qrQt">
            <div class="content-list-link">{{data.qtWe}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import { mapState } from 'vuex'

export default {
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%; height: 574px;
  margin-top: 55px;
  background: url('~@/assets/transSave/resource/image/e2/71/e29yy52b9557427a9f2496150b846671.png') center / cover no-repeat;

  @include mobile {
    width: 100%; height: 390px;
    background: url('~@/assets/transSave/resource/image/10/5d/10b6a2a0e8736af319a191c35c2fe85d.png') center / cover no-repeat;
  }
}

.banner-wrapper {
  display: flex;
  width: 1200px;
  margin: 0 auto;

  @include mobile {
    flex-wrap: wrap; justify-content: center;
    width: auto;
  }
}

.content-ai {
  display: flex; flex-direction: column; align-items: center;
  margin: 169px 64px 0 26px;

  @include mobile {
    display: auto;
    margin: 14px 0 0 0;
  }
}

.content-ai-logo {
  width: 118px;
  height: 118px;

  @include mobile {
    width: 60px; height: 60px;
  }
}

.content-ai-title-logo-content {
  margin-top: 28px;
  width: 90px;
  overflow: hidden;
}
.content-ai-title-logo {
  width: 351px;

  @include mobile {
    width: 200px;
  }
}

.content-ai-titleCh {
  margin-top: 13px;
  color: #000000;
  font-size: 46px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 63px;

  @include mobile {
    margin-top: 0;
    font-size: 22px;
    line-height: 30px;
  }
}

.content-ai-titleEn {
  color: #303030;
  font-size: 31px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 43px;
  letter-spacing: 1px;

  @include mobile {
    font-size: 16px;
    line-height: 22px;
  }
}

.content-wrapper {
  box-sizing: border-box;
  display: flex; flex-direction: column; align-items: center;
  width: 760px;
  margin-top: 90px;
  padding: 97px 79px 64px;
  background: rgba(255,255,255,0.3700);
  backdrop-filter: blur(10px);

  @include mobile {
    margin-top: 30px;
    padding: 0;
    background: none;
  }
}

.content-qr {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: 100%;

  @include mobile {
    order: 1;
    padding: 0 10px;
  }
}

.content-qr-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  // width: 186px;

  @include mobile {
    width: auto;
  }

  // &:first-child {
  //   margin-right: 80px;

  //   @include mobile {
  //     margin-right: 34px;
  //   }
  // }
}

.content-qr-img {
  width: 150px; height: 150px;

  @include mobile {
    width: 90px; height: 90px;
  }
}

.content-caption {
  color: #000000;
  font-size: 16px; font-weight: 400;
  line-height: 22px;
  opacity: 0.5;

  @include mobile {
    order: 2;
    font-size: 11px;
    line-height: 16px;
  }
}

.content-list-link {
  margin-top: 44px;
  box-sizing: border-box;
  width: 100%; height: 50px;
  // padding: 12px 35px;
  padding: 0 20px;
  background: #FFFFFF;
  line-height: 50px;
  text-align: center;
  font-size: 18px; font-weight: 500;
  color: #000000;

  @include mobile {
    margin-top: 20px;
    width: 100%; height: 32px;
    // padding: 10px 18px;
    padding: 0 8px;
    font-size: 12px; font-weight: 500;
    line-height: 32px;
  }
}
</style>
